import { render, staticRenderFns } from "./WarningView.vue?vue&type=template&id=0a5666e4&scoped=true&"
import script from "./WarningView.vue?vue&type=script&lang=ts&"
export * from "./WarningView.vue?vue&type=script&lang=ts&"
import style0 from "./WarningView.vue?vue&type=style&index=0&id=0a5666e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5666e4",
  null
  
)

export default component.exports